(function() {

    let app = angular.module('TetherApp');

    let AccessCodeListController = function (
        $window,
        accessCodeListService,
        accessCodeService,
        Upload
        ) {
            let self = this;
            self.accessCodeLists = [];
            self.errors = {};
            self.defaultPrefixLanguage = 'en';
            self.newPrefixLanguage = [];
            self.newPrefixName = [];
            self.currentKey = null;

            self.create = function() {
                tempAccessCodeList = {};
                tempAccessCodeList.name = self.newAccessCodeListName;
                tempAccessCodeList.campaign_id = self.campaignId;

                accessCodeListService.create(tempAccessCodeList)
				.then(onCreate, onCreateError);
            };

            let onCreate = function (data) {
                self.errors = {};
                self.newAccessCodeListName = '';
                self.getAccessCodeLists();
            };

            let onCreateError = function (data) {
                self.errors = {};
                self.errors.accessCodeList = data.data;
            };

            self.update = function(key) {
                accessCodeListService.update(this.accessCodeLists[key])
				.then(onUpdate, onUpdateError);
            };

            let onUpdate = function (data) {
                self.errors = {};
                self.getAccessCodeLists();
            };

            let onUpdateError = function (data) {
                self.errors = {};
                self.errors.updateAccessCodeList = data.data;
            };

            self.uploadAccessCodes = function($file, $invalidFiles, key) {
                self.invalidFiles = $invalidFiles;
                return Upload.upload({
                    url: '/api/v1/access-code/upload',
                    data: {
                        file: $file,
                        accessCodeListId: this.accessCodeLists[key].id
					}
                }).then(function (resp) {
                    self.errors = {};
                    self.getAccessCodeLists();
                }, function (resp) {
                    self.errors.csv = [];
                    self.errors.csv[key] = resp.data.errors;
                });
            };

                self.deleteAccessCodeList = function(id) {
                    accessCodeListService.deleteAccessCodeList(id)
                    .then(onDelete, function(data){});
                };

                let onDelete = function (data) {
                    self.getAccessCodeLists();
                };

                self.getAccessCodeLists = function(){
                    accessCodeListService.getAccessCodeLists(self.campaignId)
                    .then(onGetAccessCodeLists, function(data){});
                };

                let onGetAccessCodeLists = function (data) {
                    self.accessCodeLists = data;
                    // Set the default value for prefix language
                    for (let i = 0; i < data.length; i++) {
                        self.newPrefixLanguage[i] = 'en';
                    }
                };

                self.createPrefix = function(key) {
                    self.currentKey = key;
                    tempKeyword = {};
                    tempKeyword.access_code_list_id = this.accessCodeLists[key].id;
                    tempKeyword.name = this.newPrefixName[key];
                    tempKeyword.keyword = this.newPrefixName[key];
                    tempKeyword.language = this.newPrefixLanguage[key];
                    tempKeyword.is_hidden = true;
                    accessCodeListService.createPrefix(this.accessCodeLists[key].id, tempKeyword)
                    .then(onCreatePrefix, onCreatePrefixError);
                };

                let onCreatePrefix = function (data) {
                    self.errors = {};
                    self.newPrefixName[self.currentKey] = '';
                    self.newPrefixLanguage[self.currentKey] = 'en';
                    self.getAccessCodeLists();
                };

                let onCreatePrefixError = function (data) {
                    self.errors = {};
                    self.errors.createPrefix = {};
                    self.errors.createPrefix[self.currentKey] = data.data.errors;
                };

                self.updatePrefix = function(key, prefixKey) {
                    this.accessCodeLists[key].prefixes[prefixKey].keyword
                    = this.accessCodeLists[key].prefixes[prefixKey].name;

                    accessCodeListService.updatePrefix(
                        this.accessCodeLists[key].id,
                        this.accessCodeLists[key].prefixes[prefixKey]
                        )
                        .then(onUpdatePrefix, onUpdatePrefixError);
                    };

                    let onUpdatePrefix = function (data) {
                        self.getAccessCodeLists();
                    };

                    let onUpdatePrefixError = function (data) {self.errors = {};
                    self.errors = {};
                    self.errors.updatePrefix = data.data.errors;
                };

                self.deletePrefix = function(key, prefixKey) {
                    // console.log(this.accessCodeLists[key].prefixes[prefixKey]);
                    accessCodeListService.deletePrefix(
                        this.accessCodeLists[key].id,
                        this.accessCodeLists[key].prefixes[prefixKey]
                        )
                        .then(onDeletePrefix, function(data){});
                    };

                    let onDeletePrefix = function (data) {
                        self.getAccessCodeLists();
                    };
                };

                angular.module('TetherApp').controller('AccessCodeListController', [
                    '$window',
                    'accessCodeListService',
                    'accessCodeService',
                    'Upload',
                    AccessCodeListController
                ]);
            }());
